export default __webpack_public_path__ + "static/6-a37fa3612e5c9ff1137cca949ed7854f.jpg";